import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card mb-5" }
const _hoisted_3 = { class: "card-header border-0 pt-6" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = { class: "fw-bolder mb-0" }
const _hoisted_10 = { class: "card-toolbar d-flex align-items-center gap-3" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "svg-icon svg-icon-2" }
const _hoisted_13 = { class: "card-body pt-0" }
const _hoisted_14 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_15 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "svg-icon svg-icon-3" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'newsletter'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.can('create', 'newsletter'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('newsletter-sender-preview')))
                    }, [
                      _createElementVNode("span", _hoisted_6, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.translate('previewNewsletter')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2], (version) => {
          return _createElementVNode("div", {
            key: version,
            class: "card mb-5"
          }, [
            _createElementVNode("div", {
              class: "card-header border-0 cursor-pointer",
              onClick: ($event: any) => (_ctx.toggleVersion(version)),
              style: {"min-height":"60px"}
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.translate('version')) + " " + _toDisplayString(version), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.can('read', 'newsletter'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-sm btn-light-primary",
                      onClick: _withModifiers(($event: any) => (_ctx.previewVersion(version)), ["stop"])
                    }, _toDisplayString(_ctx.translate('previewNewsletter')), 9, _hoisted_11))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_inline_svg, {
                    src: 
                _ctx.expandedVersions.includes(version)
                  ? '/media/icons/duotune/arrows/arr073.svg'
                  : '/media/icons/duotune/arrows/arr072.svg'
              
                  }, null, 8, ["src"])
                ])
              ])
            ], 8, _hoisted_7),
            _withDirectives(_createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Datatable, {
                "table-data": _ctx.sectionsByVersion(version),
                "table-header": _ctx.tableHeader,
                loading: _ctx.loading,
                "rows-per-page": _ctx.sectionsByVersion(version).length || 10,
                total: _ctx.sectionsByVersion(version).length,
                "enable-items-per-page-dropdown": false
              }, {
                "cell-id": _withCtx(({ row: newsletter }) => [
                  _createTextVNode(_toDisplayString(newsletter.id), 1)
                ]),
                "cell-title": _withCtx(({ row: newsletter }) => [
                  _createTextVNode(_toDisplayString(newsletter.title), 1)
                ]),
                "cell-key": _withCtx(({ row: newsletter }) => [
                  _createTextVNode(_toDisplayString(newsletter.key), 1)
                ]),
                "cell-sort": _withCtx(({ row: newsletter }) => [
                  _createTextVNode(_toDisplayString(newsletter.sort), 1)
                ]),
                "cell-updatedAt": _withCtx(({ row: newsletter }) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(newsletter.updatedAt)), 1)
                ]),
                "cell-isEnabled": _withCtx(({ row: newsletter }) => [
                  (newsletter.isEnabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.translate('enabled')), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.translate('disabled')), 1))
                ]),
                "cell-actions": _withCtx(({ row: newsletter }) => [
                  _createElementVNode("a", {
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                    onClick: _withModifiers(($event: any) => (_ctx.editNewsletter(newsletter.id, newsletter.key)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                    ])
                  ], 8, _hoisted_16),
                  (_ctx.can('remove', 'newsletter'))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                        onClick: _withModifiers(($event: any) => (_ctx.toggleStatusNewsletter(newsletter)), ["prevent"])
                      }, [
                        _createElementVNode("span", _hoisted_19, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                        ])
                      ], 8, _hoisted_18))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["table-data", "table-header", "loading", "rows-per-page", "total"])
            ], 512), [
              [_vShow, _ctx.expandedVersions.includes(version)]
            ])
          ])
        }), 64))
      ]))
    : _createCommentVNode("", true)
}